function hasMoreThan8DecimalPlaces(num) {
  // Convert the number to a string and split it at the decimal separator
  const parts = num.toString().split('.');

  // If there is no decimal separator, the number has no decimal places
  if (parts.length !== 2) {
    return false;
  }

  // If the length of the second element is greater than 8, the number has more than 8 decimal places
  return parts[1].length > 8;
}

const isSmallerThanTwoDecimal = num => num / 100 < 0.01;

const formatDecimalPrices = (number, isCents, code) => {
  let value = number;
  if (isCents) {
    value = parseFloat((number / 100).toFixed(8));
  }

  let strValue = `${value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 8,
    currency: code.toUpperCase(),
    style: 'currency',
  })}`;
  strValue = strValue.replace(/,/g, ' ');
  return strValue;
};

function formatNumber(num, decimalPlaces = 2) {
  if (Number.isInteger(parseFloat(num))) {
    return num.toString();
  }
  return (Math.floor(num * 100) / 100).toFixed(decimalPlaces);
}

function normalizeNumber(value = 0, decimalPlaces = 2) {
  // Ensure the value is a number
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(value)) {
    console.error(`The value must be a number, ${value}`);
  }

  // Convert the number to a fixed decimal place string
  const fixedNumber = parseFloat(value).toFixed(decimalPlaces);

  // Convert it back to a number to remove any unnecessary trailing zeros
  return parseFloat(fixedNumber);
}

function renderReceiptNumber(number) {
  if (!number) {
    return '-';
  }
  return number < 999999 ? number.toString().padStart(6, '0') : number;
}

function renderInvoiceNumber(userId, number) {
  if (!userId || !number) {
    return '-';
  }
  return `${userId.toString().slice(-5).toUpperCase()}-${number}`;
}

export {
  hasMoreThan8DecimalPlaces,
  isSmallerThanTwoDecimal,
  formatDecimalPrices,
  normalizeNumber,
  renderReceiptNumber,
  renderInvoiceNumber,
  formatNumber,
};
